import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@/components/ui/dialoglogin";
import { useActionState, useEffect, useState } from "react";
import { DialogTitle } from "@radix-ui/react-dialog";
import { Input } from "@/components/ui/input";
import { api, backendApi } from "@/services/api.service";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Textarea } from "@nextui-org/react";
import { Button } from "@/components/ui/button";
import { toast } from "react-toastify";

interface AdjustBalanceProps {
  userId: string;
  userName: string;
  open: boolean;
  onClose: () => void;
  onRefetch: () => void;
}

const types = [
  {
    label: "DEBIT (Deduct)",
    value: "DEBIT",
  },
  {
    label: "CREDIT (Add)",
    value: "CREDIT",
  },
];

export const AdjustBalanceDialog = ({
  userId,
  userName,
  open,
  onClose,
  onRefetch,
}: AdjustBalanceProps) => {
  const [type, setType] = useState("DEBIT");
  const [error, formAction, isPending] = useActionState(
    async (previousState: any, formData: any) => {
      try {
        await backendApi.post("/admin/user/adjustment", {
          type,
          amount: parseInt(formData.get("amount")),
          userId: formData.get("userId"),
          notes: formData.get("notes"),
        });
        onClose();
        toast("Balance successfully adjusted", {
          type: "success",
        });
        onRefetch();
      } catch (err) {
        return err;
      }
    },
    null,
  );

  return (
    <Dialog open={open}>
      <DialogContent
        onClose={onClose}
        className={`max-h-[900px] overflow-auto bg-[linear-gradient(#021556,#020522)] bg-cover md:max-h-[95%]`}
      >
        <DialogTitle className="text-2xl text-white">{`Adjust ${userName} Balance`}</DialogTitle>
        <form
          action={formAction}
          className="flex flex-col gap-4 rounded-l-lg p-2 text-white"
        >
          <Input
            id="userId"
            name="userId"
            value={userId}
            type="text"
            placeholder="Username"
            className={`hidden`}
          />
          <div className="flex flex-col gap-4">
            <div className="flex gap-4">
              <Input
                id="amount"
                name="amount"
                required
                type="number"
                placeholder="Amount"
                className={`w-full rounded-md border-2 border-solid border-white/5 bg-white/5 px-3 py-2 text-white placeholder:text-white/40 sm:text-sm`}
              />
              <Select value={type} onValueChange={(e) => setType(e)}>
                <SelectTrigger className="w-full border-2 border-white/5 bg-white/5 text-white">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className="border-2 border-white/5 bg-[#14142A]">
                  {types.map((item) => (
                    <SelectItem
                      key={item.value}
                      value={item.value}
                      className="w-full"
                    >
                      <div className="flex w-full items-center justify-between gap-2">
                        <div className="flex items-center">
                          <div className="text-xs text-white">{item.label}</div>
                        </div>
                      </div>
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <Textarea
              id="notes"
              name="notes"
              type="text"
              placeholder="Notes"
              className={`h-[8rem] w-full rounded-md border-2 border-solid border-white/5 bg-white/5 text-white placeholder:text-white/40 sm:text-sm`}
            />
          </div>
          <Button
            className={`bg-button-gradient ${isPending && "bg-gray"}`}
            disabled={isPending}
            type="submit"
          >
            Submit
          </Button>
          {error !== null && (
            <p className="text-xs font-[500] text-danger">
              {error?.toString()}
            </p>
          )}
        </form>
      </DialogContent>
    </Dialog>
  );
};
